import { render } from "./PiBotSettings.vue?vue&type=template&id=86a921be"
import script from "./PiBotSettings.vue?vue&type=script&lang=js"
export * from "./PiBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__